import { render, staticRenderFns } from "./LiveDetailCardNew.vue?vue&type=template&id=8d46f53e&scoped=true"
import script from "./LiveDetailCardNew.vue?vue&type=script&lang=js"
export * from "./LiveDetailCardNew.vue?vue&type=script&lang=js"
import style0 from "./LiveDetailCardNew.vue?vue&type=style&index=0&id=8d46f53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d46f53e",
  null
  
)

export default component.exports